/**
 * Get organization url Returns a valid organization url including the login
 * token ang organization id
 *
 * @param args - Arguments for getOrganizationUrl
 */
export const getOrganizationUrl = ({ loginToken, organization, url, }) => {
    const urlHost = url.host.replace('www.', '');
    const urlOrigin = url.origin.replace('www.', '');
    const urlCaptures = urlHost.match(/(.*?)\.(.*?)\.(.*)/);
    const domain = urlCaptures === null || urlCaptures === void 0 ? void 0 : urlCaptures[2];
    const topLevelDomain = urlCaptures === null || urlCaptures === void 0 ? void 0 : urlCaptures[3];
    const shouldIncludePath = url.host.includes('dixadev.com');
    const path = shouldIncludePath ? `${url.pathname}/` : '/';
    const cleanPath = path.replace(/\/+/g, '/');
    const origin = (urlCaptures === null || urlCaptures === void 0 ? void 0 : urlCaptures.length) === 4
        ? `https://${organization.subdomain}.${domain}.${topLevelDomain}`
        : `${urlOrigin}`;
    return `${origin}${cleanPath}?loginToken=${loginToken}&orgId=${organization.id}`;
};
